import {
  RESET,
  SET_CURRENT_STEP,
  SET_SELECTED_EVENT_TYPE,
  SAVE_GIFT_TABLE,
  SAVE_GIFT_TABLE_SUCCESS,
  SAVE_GIFT_TABLE_FAILED,
} from 'store/actions/giftTableFlow/types';

export const initialState = {
  currentStep: 1,
  selectedEventType: {},
  saveGiftTable: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: {},
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    case SET_SELECTED_EVENT_TYPE:
      return {
        ...state,
        selectedEventType: action.payload,
      };
    case SAVE_GIFT_TABLE:
      return {
        ...state,
        saveGiftTable: {
          ...initialState.saveGiftTable,
          loading: true,
        },
      };
    case SAVE_GIFT_TABLE_SUCCESS:
      return {
        ...state,
        saveGiftTable: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
        },
      };
    case SAVE_GIFT_TABLE_FAILED:
      return {
        ...state,
        saveGiftTable: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.saveGiftTable.data,
        },
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};
